export const PAYMENT_TYPE_ONLINE = 'ONLINE';
export const PAYMENT_TYPE_CASH_ON_DELIVERY = 'CASH_ON_DELIVERY';

export const PAYMENT_ONLINE_COMPONENT = {
    title: 'پرداخت آنلاین',
    subtitle: 'پرداخت از طریق درگاه‌ بانکی',
    id: PAYMENT_TYPE_ONLINE,
    type: 'SADAD'
} as const;

export const PAYMENT_CASH_ON_DELIVERY_COMPONENT = {
    label: 'پرداخت در محل',
    subTitle: 'پرداخت کل مبلغ در زمان انجام کارشناسی',
    id: PAYMENT_TYPE_CASH_ON_DELIVERY
} as const;

export const paymentGatewaysTypeId = {
    azkivam: 'AZKIVAM',
    sadad: 'SADAD',
    saman: 'SAMAN',
    zarinpal: 'ZARINPAL',
    digipay: 'DIGIPAY',
    blubank: 'BLUBANK',
    snappay: 'SNAPPAY'
} as const;

type InstalmentDueAnchor = 'sameDay' | 'monthStart' | 'monthEnd';

type InstalmentDueStep = {
    title: string;
    anchor: InstalmentDueAnchor;
    monthsAhead: number;
};

const payAtPurchaseThenMonthStarts: InstalmentDueStep[] = [
    { title: 'قسط اول', anchor: 'sameDay', monthsAhead: 0 },
    { title: 'قسط دوم', anchor: 'monthStart', monthsAhead: 1 },
    { title: 'قسط سوم', anchor: 'monthStart', monthsAhead: 2 },
    { title: 'قسط چهارم', anchor: 'monthStart', monthsAhead: 3 }
];

const snappayDueSteps: InstalmentDueStep[] = [
    { title: 'قسط اول', anchor: 'sameDay', monthsAhead: 0 },
    { title: 'قسط دوم', anchor: 'monthEnd', monthsAhead: 1 },
    { title: 'قسط سوم', anchor: 'monthEnd', monthsAhead: 2 },
    { title: 'قسط چهارم', anchor: 'monthEnd', monthsAhead: 3 }
];

const blubankDueSteps: InstalmentDueStep[] = [
    { title: 'قسط اول', anchor: 'sameDay', monthsAhead: 1 },
    { title: 'قسط دوم', anchor: 'sameDay', monthsAhead: 2 },
    { title: 'قسط سوم', anchor: 'sameDay', monthsAhead: 3 },
    { title: 'قسط چهارم', anchor: 'sameDay', monthsAhead: 4 }
];

export const instalmentDueStepsByGateway = {
    [paymentGatewaysTypeId.azkivam]: payAtPurchaseThenMonthStarts,
    [paymentGatewaysTypeId.digipay]: payAtPurchaseThenMonthStarts,
    [paymentGatewaysTypeId.snappay]: snappayDueSteps,
    [paymentGatewaysTypeId.blubank]: blubankDueSteps
};

export const getInstalmentDueSteps = (type: string) => instalmentDueStepsByGateway[type as keyof typeof instalmentDueStepsByGateway] ?? [];
